module.exports = __webpack_public_path__ + "static/media/play-large.95ff1fe9.svg";